import { DAILY_SALES_DEFAULT_DAYS } from '@bonsai/shared';
import { AlertTriangle } from 'lucide-react';

import { DailySalesError } from '../../../../api/daily-sales';
import { BucketError } from '../../regional/BucketStates';

interface DailySalesFailureProps {
  error: unknown;
  onReset: () => void;
  onRetry: () => void;
  onAllRegions: () => void;
}

/**
 * Why the report could not be shown. Refused dates name the reason and offer the default
 * range back; a refused region offers every region back; a failure that may pass offers
 * to try again; a missing permission offers nothing, since trying again would not help.
 */
export function DailySalesFailure({
  error,
  onReset,
  onRetry,
  onAllRegions,
}: DailySalesFailureProps) {
  const known = error instanceof DailySalesError ? error : null;
  const reason = known?.refusedReason;
  if (reason) {
    return (
      <div role="alert" className="nb-ds-refused">
        <AlertTriangle size={18} aria-hidden="true" className="nb-ds-refused-icon" />
        <p>
          <strong>Those dates can&apos;t be shown.</strong> {reason}
        </p>
        <button type="button" className="nb-btn" onClick={onReset}>
          Back to last {DAILY_SALES_DEFAULT_DAYS} days
        </button>
      </div>
    );
  }

  if (known?.isRefusedRegion) {
    return (
      <div className="nb-ds-failure">
        <BucketError error={known} />
        <button type="button" className="nb-btn" onClick={onAllRegions}>
          Show all regions
        </button>
      </div>
    );
  }

  return (
    <div className="nb-ds-failure">
      <BucketError error={error} />
      {known?.status !== 403 && (
        <button type="button" className="nb-btn" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}
